import React from "react";

export const LocationImage = ({ url }) => {
  const alt = "Location Image/PWM Logo";

  return (
    <img
      src={
        url
          ? url
          : "https://s3.amazonaws.com/printwithme.com/images/v2_logos/pwm_logo_med.png"
      }
      alt={alt}
      className="w-100"
    />
  );
};
